import React, { useState } from 'react'
import { Popover } from '@mui/material'
import { LuChevronDown } from 'react-icons/lu'

const BUREAU_ORDER = ['Equifax', 'Experian', 'TransUnion']

const PdfBureauButton = ({ reportMap, openPdf, pdfLoading }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [activeBureau, setActiveBureau] = useState(null)

  const bureaus = BUREAU_ORDER.filter(b => reportMap[b])
  if (bureaus.length === 0) return null

  const selected = activeBureau && reportMap[activeBureau] ? activeBureau : bureaus[0]

  const handleClick = () => {
    openPdf(reportMap[selected])
  }

  const handleChevronClick = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const handleSelect = (bureau) => {
    setActiveBureau(bureau)
    setAnchorEl(null)
    openPdf(reportMap[bureau])
  }

  const baseClasses = 'text-sm font-semibold text-text-primary border border-divider transition-colors disabled:opacity-50'
  const hoverClasses = 'enabled:hover:bg-[color-mix(in_srgb,var(--color-primary-main)_10%,transparent)] enabled:hover:border-primary-main'

  // Single bureau — plain button
  if (bureaus.length === 1) {
    return (
      <button
        type="button"
        disabled={pdfLoading}
        onClick={handleClick}
        className={`px-2.5 py-1.5 rounded-lg ${baseClasses} ${hoverClasses}`}
      >
        {pdfLoading ? 'Loading...' : 'View PDF'}
      </button>
    )
  }

  // Multiple bureaus — split button
  return (
    <div className="inline-flex">
      <button
        type="button"
        disabled={pdfLoading}
        onClick={handleClick}
        className={`px-2.5 py-1.5 rounded-l-lg rounded-r-none border-r-0 ${baseClasses} ${hoverClasses}`}
      >
        {pdfLoading ? 'Loading...' : 'View PDF'}
      </button>
      <button
        type="button"
        aria-label="Select bureau"
        disabled={pdfLoading}
        onClick={handleChevronClick}
        className={`px-1.5 py-1.5 rounded-r-lg rounded-l-none ${baseClasses} ${hoverClasses}`}
      >
        <LuChevronDown size={16} />
      </button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <div className="flex flex-col py-1 min-w-[140px]">
          {bureaus.map(bureau => (
            <button
              key={bureau}
              type="button"
              onClick={() => handleSelect(bureau)}
              className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-surface w-full text-left bg-transparent border-none"
            >
              <span className={`w-1.5 h-1.5 rounded-full ${bureau === selected ? 'bg-primary-main' : 'bg-transparent'}`} />
              {bureau}
            </button>
          ))}
        </div>
      </Popover>
    </div>
  )
}

export default PdfBureauButton
